
import {
	computed,
	defineComponent,
	inject,
	onMounted,
	nextTick,
	ref,
	watch,
} from 'vue';
import ChevronDownIcon from '@/components/ui-elements/icons/ChevronDownIcon.vue';
import { FormProvider } from '@/components/ui-elements/form/Form';
import Label from '@/components/ui-elements/form/Label.vue';

type SelectItems = Array<{ label: string; value: string }>;

export default defineComponent({
	components: {
		ChevronDownIcon,
		Label,
	},
	props: {
		label: {
			default: '',
			type: String,
		},
		rules: {
			default: () => ({}),
			type: Object,
		},
		items: {
			required: true,
			type: Array as () => SelectItems,
		},
		itemLabel: {
			default: 'label',
			type: String,
		},
		itemValue: {
			default: 'value',
			type: String,
		},
		placeholder: {
			default: 'Select',
			type: String,
		},
		value: {
			required: true,
			type: String,
		},
		isDisabled: {
			default: false,
			type: Boolean,
		},
	},
	setup(props, { emit }) {
		const error = ref(false);
		const selected = ref(false);
		const dropDownItems = ref(null);
		const labelId = ref<string>('');
		const FormContext = inject<any>(FormProvider, undefined);

		onMounted(() => {
			(dropDownItems.value as any).classList.add('h-0', 'py-0');
			if (props.label && !!FormContext) {
				labelId.value = FormContext.setupForm(props.label, props.rules);
				FormContext.validateField(labelId.value, props.value);
			}
		});

		const isValueSelected = computed(
			() => props.value && (Number(props.value) > 0 || props.value.length)
		);

		const getPlaceholder = computed(() => {
			const text: any = props.items.find(
				(obj: any) => props.value === obj[props.itemValue]
			);

			if (isValueSelected.value && text && text[props.itemLabel]) {
				return text[props.itemLabel];
			}

			return props.placeholder;
		});

		const handleClick = () => {
			if (!props.isDisabled) {
				selected.value = !selected.value;
			}
		};

		const setValue = (value: string) => {
			if (FormContext) {
				error.value = FormContext.validateField(labelId.value, value);
			}
			emit('update:value', value);
			emit('set-item', value);
		};

		const blurEvent = () => {
			if (!props.isDisabled) {
				selected.value = false;
				setValue(props.value);
			}
		};

		watch(
			() => props.value,
			val => {
				nextTick(() => {
					if (FormContext) {
						if (!props.isDisabled) {
							error.value = FormContext.validateField(
								labelId.value,
								val
							);
						} else {
							FormContext.validateField(labelId.value, val);
						}
					}
				});
			}
		);

		watch(selected, n => {
			if (!n) {
				setTimeout(
					() =>
						(dropDownItems.value as any).classList.add(
							'h-0',
							'py-0'
						),
					300
				);
			} else {
				(dropDownItems.value as any).classList.remove('h-auto', 'py-1');
			}
		});

		return {
			blurEvent,
			dropDownItems,
			error,
			getPlaceholder,
			handleClick,
			labelId,
			selected,
			setValue,
		};
	},
});
